/* eslint-disable max-len */
import Logo from '../../../../assets/social.png';
import {API_ENDPOINT_JSON} from '../../../../config';

import {
  childLaborTabQuestions,
  customerHealthAndSafetyTabQuestions,
  customerPrivacyTabQuestions,
  diversityOfGovernanceBodiesAndEmployeesTabQuestions,
  employmentTabQuestions,
  forcedLaborTabQuestions,
  freedomOfAssociationAndCollectiveBargainingTabQuestions,
  humanRightsAssessmentTabQuestions,
  laborManagementRelationsTabQuestions,
  localCommunitiesTabQuestions,
  marketPresenceTabQuestions,
  nonDiscriminationTabQuestions,
  occupationalHealthAndSafetyTabQuestions,
  ratioOfBasicSalaryAndRemunerationOfWomenToMenTabQuestions,
  rightsOfIndigenousPeoplesTabQuestions,
  securityPracticesTabQuestions,
  socioeconomicComplianceTabQuestions,
  supplierSocialAssessmentTabQuestions,
  trainingAndEducationTabQuestions,
  workRelatedIllHealthTabQuestions,
  workRelatedInjuriesTabQuestions
} from './socialTabs';

export const social = {
  header: {
    imageUrl: Logo,
    title: 'Social',
    description: `Concerns a company's approach and impact on societal factors,
      including labor practices, diversity, community engagement, and human rights.`,
    noOfModules: 21,
    answeredQuestions: 16,
    totalQuestions: 65
  },
  APIRoute: API_ENDPOINT_JSON.ESG.GRI.social,
  tabs: [
    {
      id: 'diversityOfGovernanceBodiesAndEmployees',
      title: 'Diversity of governance bodies and employees',
      questions: diversityOfGovernanceBodiesAndEmployeesTabQuestions
    },
    {
      id: 'ratioOfBasicSalaryAndRemunerationOfWomenToMen',
      title: 'Ratio of basic salary and remuneration of women to men',
      questions: ratioOfBasicSalaryAndRemunerationOfWomenToMenTabQuestions
    },
    {
      id: 'employment',
      title: 'Employment',
      questions: employmentTabQuestions
    },
    {
      id: 'laborManagementRelations',
      title: 'Labor/Management Relations',
      questions: laborManagementRelationsTabQuestions
    },
    {
      id: 'securityPractices',
      title: 'Security Practices',
      questions: securityPracticesTabQuestions
    },
    {
      id: 'rightsOfIndigenousPeoples',
      title: 'Rights of Indigenous Peoples',
      questions: rightsOfIndigenousPeoplesTabQuestions
    },
    {
      id: 'humanRightsAssessment',
      title: 'Human Rights Assessment',
      questions: humanRightsAssessmentTabQuestions
    },
    {
      id: 'localCommunities',
      title: 'Local communities',
      questions: localCommunitiesTabQuestions
    },
    {
      id: 'marketPresence',
      title: 'Market Presence',
      questions: marketPresenceTabQuestions
    },
    {
      id: 'freedomOfAssociationAndCollectiveBargaining',
      title: 'Freedom of Association and Collective Bargaining',
      questions: freedomOfAssociationAndCollectiveBargainingTabQuestions
    },
    {
      id: 'nonDiscrimination',
      title: 'Non-discrimination',
      questions: nonDiscriminationTabQuestions
    },
    {
      id: 'childLabor',
      title: 'Child Labor',
      questions: childLaborTabQuestions
    },
    {
      id: 'forcedLabor',
      title: 'Forced Labor',
      questions: forcedLaborTabQuestions
    },
    {
      id: 'occupationalHealthAndSafety',
      title: 'Occupational Health and Safety',
      questions: occupationalHealthAndSafetyTabQuestions
    },
    {
      id: 'workRelatedInjuries',
      title: 'Work-related injuries',
      questions: workRelatedInjuriesTabQuestions
    },
    {
      id: 'workRelatedIllHealth',
      title: 'Work-related ill health',
      questions: workRelatedIllHealthTabQuestions
    },
    {
      id: 'trainingAndEducation',
      title: 'Training and Education',
      questions: trainingAndEducationTabQuestions
    },
    {
      id: 'supplierSocialAssessment',
      title: 'Supplier Social Assessment',
      questions: supplierSocialAssessmentTabQuestions
    },
    {
      id: 'customerHealthAndSafety',
      title: 'Customer Health and Safety',
      questions: customerHealthAndSafetyTabQuestions
    },
    {
      id: 'customerPrivacy',
      title: 'Customer Privacy',
      questions: customerPrivacyTabQuestions
    },
    {
      id: 'socioeconomicCompliance',
      title: 'Socioeconomic Compliance',
      questions: socioeconomicComplianceTabQuestions
    }
  ]
};
